import React from "react";
import { Link } from "react-router-dom";

export default class LinkCell extends React.Component {
    render() {
        return <Link to={this.props.column.to(this.props.row)}>{this.props.value}</Link>;
    }
}
